import React, {Component} from "react"
import PropTypes from 'prop-types'
import {connect} from "react-redux"
import {Col, Fade, Grid, Row} from 'react-bootstrap'
import Header from "../components/Header"
import Footer from "../components/Footer"
import {hideModal} from "../actions/modal"
import {loadSeasons} from "../actions/online";
import {resetAlerts} from "../actions"
import {renderIsFetchingData} from "../components/utils/grid"
import {defaultState} from "../reducers/paginate";

class App extends Component {

	alertsTimeout = null;

	componentWillMount() {
		this.props.loadSeasons();
	}

	handleDismissClick = e => {
		this.props.resetAlerts();
		if (this.alertsTimeout) {
			clearTimeout(this.alertsTimeout)
		}
		if (e) {
			e.preventDefault()
		}
	};

	renderAlerts() {
		const {alerts} = this.props;

		const items = [];
		if (alerts.messages.length) {
			for (let k in alerts.messages) {
				if (alerts.messages.hasOwnProperty(k)) {
					items.push(<div key={k}>{alerts.messages[k]}</div>)
				}
			}
			if (this.alertsTimeout) {
				clearTimeout(this.alertsTimeout)
			}
			if (alerts.type === "success") {
				this.alertsTimeout = setTimeout(this.props.resetAlerts, 5000)
			}
		}

		return (
			<Fade in={alerts.messages.length > 0}>
				<div className="alert-top">
					<div className={"alert-inner alert alert-" + alerts.type + (alerts.messages.length ? "" : " hidden")}>
						<button className="pull-right btn btn-xs" onClick={this.handleDismissClick}>x</button>
						{items}
					</div>
				</div>
			</Fade>
		)
	}

	render() {
		const {children, error, seasonsPage} = this.props;

		if (!seasonsPage || seasonsPage.isFetchingItems || seasonsPage.items === null) {
			return renderIsFetchingData("Aplikace se nahrává ...")
		}

		return (
			<Grid>
				<Header error={error}/>
				{this.renderAlerts()}
				<Row>
					<Col xs={12} className={"main-content"}>
						<main>
							{children}
						</main>
					</Col>
				</Row>
				<Footer/>
			</Grid>
		)
	}
}

App.propTypes = {
	headerContent: PropTypes.node,
	loadSeasons: PropTypes.func.isRequired,
	seasonsPage: PropTypes.object,
	alerts: PropTypes.object.isRequired,
	resetAlerts: PropTypes.func.isRequired,
	modal: PropTypes.object.isRequired,
	hideModal: PropTypes.func.isRequired,
	enums: PropTypes.object,
	// Injected by React Router
	children: PropTypes.node
};

const mapStateToProps = (state, ownProps) => {
	const {
		alerts,
		modal,
		enums,
		error,
		pagination: {seasons}
	} = state;

	const seasonsPage = seasons[0] || defaultState;

	return {
		alerts,
		modal,
		enums,
		error,
		seasonsPage
	}
};

export default connect(mapStateToProps, {
	loadSeasons,
	resetAlerts,
	hideModal
})(App)


// WEBPACK FOOTER //
// ./P:/Work/htdocs/biatlon/online/src/containers/App.js